import { connect } from "react-redux";
import { translate, t } from "react-multi-lang";
import React, { useEffect, useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";

import { saveReportUserStart } from "../../store/actions/UserAction";
import { getSiteName } from "../../utils/brandingConfig";

const ReportUserModal = (props) => {
  const [reason, setReason] = useState(0);
  const siteName = getSiteName();

  const reasons = [
    `This content is offensive or violates ${siteName} Terms of Services`,
    "This content contains stolen material (DMCA)",
    "This content is spam",
    "Report Abuse",
  ];

  useEffect(() => {
    if (props.saveReportUser.loading) {
      setReason(0);
      props.close();
    }
  }, [props.saveReportUser]);

  const handleReport = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (reason === null) return;

    const data = {
      reason: reasons[reason],
      user_id: props?.data?.user_id
    };
    props.dispatch(saveReportUserStart(data));
  };

  const handleRadioButtonClick = (value) => {
    setReason(value);
  };

  return (
    <>
      <Modal
        size="lg"
        centered
        show={props.show}
        onHide={props.close}
        className={`verify light'}`}
      >
        <Form translate="no">
          <Modal.Body>
            <h2 className="text-center mt-4 bold mb-4">{t("report_user")}</h2>
            <div className="report-form">
              <Form.Group>
                <div onClick={() => handleRadioButtonClick(0)}>
                  <Form.Check
                    type="radio"
                    label={`Their content is offensive or violates ${siteName} Terms of Services`}
                    custom
                    checked={reason === 0}
                  />
                </div>
              </Form.Group>
              <Form.Group>
                <div onClick={() => handleRadioButtonClick(1)}>
                  <Form.Check
                    type="radio"
                    label="Their content contains stolen material (DMCA)"
                    custom
                    checked={reason === 1}
                  />
                </div>
              </Form.Group>
              <Form.Group>
                <div onClick={() => handleRadioButtonClick(2)}>
                  <Form.Check
                    type="radio"
                    label="Their content is spam"
                    custom
                    checked={reason === 2}
                  />
                </div>
              </Form.Group>
              <Form.Group>
                <div onClick={() => handleRadioButtonClick(3)}>
                  <Form.Check
                    type="radio"
                    label="Report Abuse"
                    custom
                    checked={reason === 3}
                  />
                </div>
              </Form.Group>
            </div>
          </Modal.Body>
          <div className="footer">
            <Button variant="default" onClick={props.close}>
              {t("cancel")}
            </Button>
            <Button
              variant="default"
              type="submit"
              onClick={handleReport}
              disabled={props.saveReportUser?.loadingButtonContent}
            >
              <div>
                {props.saveReportUser?.loadingButtonContent || t("report")}
              </div>
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

const mapStateToPros = (state) => ({
  saveReportUser: state.users.saveReportUser,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(translate(ReportUserModal));
